<template>
  <div class="wrapper signup-page-wrp">
    <div class="signup-page">
      <div class="signup-page-left">
        <div class="align">
          <h1>Company Profile</h1>
        </div>
      </div>
      <div class="signup-page-right">
        <div class="align">
          <form class="signin-form">
            <div class="step-holder">
              <div class="tab-heading">
                <h1>Company Information</h1>
              </div>

              <!-- Step 1 -->
              <div class="steps">
                <div class="comp-info-step">
                  <div class="row">
                    <div class="col-sm-8 pd-lr">
                      <div class="form-group">
                        <label >Company Name *</label>
                        <div class="input-wrapper">
                          <input
                            type="email"
                            class="form-control form-control-lg"
                            value=""
                            placeholder=""
                            v-model="form.name"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4 pd-lr">
                      <div class="form-group">
                        <label >CVR</label>
                        <input
                          type="number"
                          class="form-control form-control-lg"
                          placeholder=""
                          v-model="form.cvr"
                        />
                      </div>
                    </div>
                    <div class="col-sm-8 pd-lr">
                      <div class="form-group">
                        <label >Address *</label>
                        <div class="input-wrapper">
                          <input
                            type="text"
                            class="form-control form-control-lg"
                            value=""
                            placeholder=""
                            id="companyAddress"
                            v-model="form.address"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4 pd-lr">
                      <div class="form-group">
                        <label >Post Code</label>
                        <div class="input-wrapper">
                          <input
                            type="number"
                            class="form-control form-control-lg"
                            placeholder=""
                            v-model="form.postcode"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-8 pd-lr">
                      <div class="form-group">
                        <label >Country *</label>
                        <div class="input-wrapper">
                          <select class="form-control form-control-lg countryWithCurrency" v-model="form.country" @change="selectCurrency" id="country">
                              <option v-for="(country,index) of countries" :key="index" :id_attr="country.id"> {{ country.country }} </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4 pd-lr">
                      <div class="form-group">
                        <label >Currency *</label>
                        <select class="form-control form-control-lg " v-model="form.currency_id">
                            <option v-for="(currency,index) of currencies" :key="index" :value="currency.id"> {{ currency.code }} </option>
                        </select>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="update-link">
                  <router-link to="/tax-slabs" class="">
                    Add/Update Income Tax Settings</router-link
                  >
                </div>
              </div>

              <div class="tab-foot text-center">
                <router-link :to="{ path: '/my-companies' }">
                  <a class="btn btn-lg btn-outline-primary"> Cancel</a>
                </router-link>
                <a class="btn btn-lg btn-primary" :disabled="this.isDisabled" @click.prevent="saveNewCompany"
                  >Save</a
                >
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import login from "../Login/login.vue";
import Multiselect from "vue-multiselect";
import {minLength, required} from "vuelidate/lib/validators";
export default {
  name: "signup",

  components: {
    Multiselect,
  },

  data() {
    return {
      form: {
        name: null,
        cvr: null,
        address: null,
        postcode: null,
        industry_id: 1,
        latitude: "31.5204",
        longitude: "74.3587",
        jobRoles: [],
        currency_id:'',
        country:''
      },
      options: [{ name: "Cleaner" }, { name: "Cook" }, { name: "Chef" }],
      value: [],
      jobroles_list: [],
      countries:[],

      currencies:[]
    };
  },
  mounted() {
    // this.jobslist();
    this.getCountries();
    this.registerLocation();
  },
  validations: {
    form: {
      name: {required},
      address: {required},
      country: {required},
      currency_id: {required},
      // confirmPassword: { required, sameAsPassword: sameAs("password") },
    },
  },
  created() {
    return this.$v.$touch();
  },
  computed: {
    isDisabled() {
      return this.$v.$invalid;
    },
  },
  methods: {
    selectCurrency(){
      this.form.currency_id = $('.countryWithCurrency :selected').attr('id_attr');
    },
    saveNewCompany() {
      this.is_data_ready = false;
      this.form.jobRoles = JSON.stringify(this.value);
      this.$v.$touch();
      if (this.$v.$invalid) {
        alert('All start(*) field are required');
        return false; // stop here if form is invalid
      }else{
        this.$axios
          .post(this.$NewCompany, this.form, {
            headers: this.getAuthHeader(),
          })
          .then((response) => {
            this.$store.commit('setUser',response.data.result.company.user);
            $root.$toast.success(response.data.message);
            this.$router.push("/my-companies");
          })
          .catch((error) => {
            console.log(error);
            this.is_data_ready = true;
          });
      }

    },


    getCountries(){
      this.$axios({
            method: 'get',
            url: this.$GetCountries,
        }).then(response => {
            if(response.data.status === 200){
              this.countries = response.data.result;
              this.currencies = response.data.result;
            }
        })
    },
  getCurrencies(){
    this.$axios({
          method: 'get',
          url: this.$GetCurrencies,
      }).then(response => {
        //console.log(response,'currencesesss')
          if(response.data.status === 200){
            this.currencies = response.data.result;
          }
      })
  },
    registerLocation(scope = this){
      let address = document.getElementById('companyAddress');
      const autocomplete = new google.maps.places.Autocomplete((address));
      autocomplete.addListener('place_changed', function () {
        let addressComponent = autocomplete.getPlace().address_components;
       // console.log(addressComponent);
        for (var i=0; i < addressComponent.length; i++) {
          for (var b=0; b < addressComponent[i].types.length; b++) {
            if (addressComponent[i].types[b] == "country") {
              scope.form.country = addressComponent[i].long_name;
              let selectedCountry = scope.countries.filter(function (country) {
                return country.country == addressComponent[i].long_name;
              });
              if(selectedCountry.length > 0){
                scope.form.currency_id = selectedCountry[0].id;
              }
            }
            if (addressComponent[i].types[b] == "postal_code") {
              scope.form.postcode = addressComponent[i].long_name;
            }
          }
        }
        scope.form.address = autocomplete.getPlace().formatted_address;
      });
    },
  },
};
</script>
